// extracted by mini-css-extract-plugin
export default {"formInput":"Input_formInput__n1-NO"};